let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("7erVk")).then(() => parcelRequire('g4I8Z'));